import { useContext } from "react";
import BryntumContext from "@/react/context/bryntumContext";
import { GRANTS } from "@/other/constants/PrivilegeTypes";
import { isIAmOneOfBoardOwner } from "@/other/utils/utils";

/**
 * Custom hook to check board-level permissions for settings
 *
 * Returns permission flags for the current user:
 * - canRead: User has scheduler+ role (required to view settings)
 * - canWrite: User is board owner and not a demo user (required to modify settings)
 * - isBoardOwner: User is one of the board owners
 *
 * @returns Object containing permission flags
 */
export const useBoardPermissions = () => {
  const { user, project, boardManager, selectedBoard } = useContext(BryntumContext);

  // Check if user has scheduler+ role for read access
  const canRead = user?.can(GRANTS.grant_three); // scheduler+

  // Permission check: board owner only, excluding demo users
  // @ts-expect-error - boardManager is dynamically set in bryntumContext
  const boardStore = boardManager?.boardNameStore?.getById(selectedBoard?.id);
  const isBoardOwner = project && boardStore ? isIAmOneOfBoardOwner(project, boardStore.owner) : false;
  const canWrite = isBoardOwner && !user?.isDemoUser;

  return {
    canRead,
    canWrite,
    isBoardOwner
  };
};
